import axios from "axios";
import React from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { API_URL } from "../config";

export const StyledLogoutButton = styled.button`
  background: transparent;
  padding: 0;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
`;

const LogoutButton = ({ history, closeOptions, refetchUser }) => {
  const signout = () =>
    axios({
      method: "POST",
      url: `${API_URL}/signout`,
      withCredentials: true,
    });

  return (
    <StyledLogoutButton
      onClick={() => {
        signout().then(() => {
          refetchUser().then(() => {
            closeOptions();
          });
        });
      }}
    >
      Log out
    </StyledLogoutButton>
  );
};

export default withRouter(LogoutButton);
